import React from 'react';
import styles from './ComingSoon.module.css';

const ComingSoon = () => {
  return (
    <div className={styles.comingSoonContainer}>
      <div className={styles.comingSoonIcon}>🚧</div>
      <p className={styles.comingSoonText}>Feature Coming Soon</p>
    </div>
  );
};

export default ComingSoon; 